// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"9ae9da39","87":"e1c2a85d","320":"066e9df9","379":"6ef76ed4","469":"d4724423","496":"0dc29a9b","498":"f454ac80","627":"7e91c795","703":"81fdf65f","787":"06044102","987":"30c43c2d"}[chunkId] + ".chunk.js";
};